import React from 'react';

export default function ScheduleTimelineItem(props) {
    return (
        <div>Schedule - Not yet implemented</div>
    );
}


// WEBPACK FOOTER //
// ./app/components/client-timeline/items/ScheduleTimelineItem.js